import React from 'react';
import { Marker } from '@react-google-maps/api';

//STYLES
import { iconePontoMalha, labelPontoMalha } from './styled';

//APP
import { GeoPointFeature } from '../..';
import { chavePonto } from '../selecaoEmMassa/meta';

interface PropsMarkersMalha {
    pontos: GeoPointFeature[]
    /** Vazio = nenhuma análise escolhida; sem ela os pontos não são exibidos. */
    tipo_analise_selecionada: string
    /** Chaves dos pontos que já pertencem a outra análise (adicionada ou salva). */
    pontos_ja_usados: Set<string>
    /** Libera arrastar o marker para reposicionar o ponto. */
    moverPontos: boolean
    moverPontosMalha: (index: number, event: google.maps.MapMouseEvent) => void
    selecionarPontosMalha: (index: number) => void
}

/**
 * Markers dos pontos da malha sobre o mapa.
 *
 * Precisa ficar como filho direto de `<GoogleMap />` — o `Marker` do
 * @react-google-maps/api se registra no mapa pelo contexto, não pelo DOM.
 *
 * Cada ponto tem três estados: nunca usado (pin branco, número leve), já usado por outra
 * análise (pin branco, número em negrito) e selecionado agora (pin na cor da análise).
 */
export const MarkersMalha: React.FC<PropsMarkersMalha> = ({ pontos, tipo_analise_selecionada,
    pontos_ja_usados, moverPontos, moverPontosMalha, selecionarPontosMalha
}) => {

    if (!tipo_analise_selecionada) return null

    return (
        <>
            {pontos.map((ponto, index) => {
                const lat = Number(ponto.LATITUDE)
                const lng = Number(ponto.LONGITUDE)
                /* Cai no índice quando o ponto ainda não tem nome (recém-inserido no mapa). */
                const texto_label = ponto.NOME ? ponto.NOME.toString() : (index + 1).toString()
                const chave = `${ponto.NOME || ponto.id || index}-${lat}-${lng}`
                const ja_usado = pontos_ja_usados.has(chavePonto(ponto))

                return (
                    <Marker
                        key={chave}
                        position={{ lat, lng }}
                        draggable={moverPontos}
                        onDragEnd={(event) => moverPontosMalha(index, event)}
                        onClick={() => selecionarPontosMalha(index)}
                        label={labelPontoMalha(texto_label, ponto.COR, ja_usado)}
                        icon={iconePontoMalha(ponto.COR)}
                    />
                )
            })}
        </>
    )
}
